import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navbar() {
  const navigate = useNavigate();
  const { isAuthenticated, logout, userInfo } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '2rem',
      background: '#0740a3',
      borderBottom: '1px solid #eee',
      height: '75px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
        <img src={process.env.PUBLIC_URL + '/images/bt-logo.svg'} alt="Better Trucks" style={{ height: 40, marginRight: 16 }} />
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        {isAuthenticated && (
          <>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '1rem',
              padding: '0.25rem 0.75rem',
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '4px',
              color: '#fff'
            }}>
              <i className="bi bi-person-circle me-2" style={{ fontSize: '14px' }}></i>
              <span style={{ fontWeight: 500, fontSize: '14px' }}>
                {userInfo?.email || 'User'}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-outline-light btn-sm"
              style={{ fontWeight: 600 }}
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Logout
            </button>
          </>
        )}
        {!isAuthenticated && (
          <button
            onClick={() => navigate('/login')}
            className="btn btn-outline-light btn-sm"
            style={{ fontWeight: 600 }}
          >
            <i className="bi bi-box-arrow-in-right me-1"></i>
            Login
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;